export { default } from './SLAKPITab'
